import React from "react";
import FormattedDate from "./FormattedDate";
import WeatherUnitConversion from "./WeatherUnitConversion";

export default function WeatherInfo(props) {
  return (
    <div className="WeatherInfo">
      <div className="row mt-3 mb-5">
        <div className="col-6 ">
          <h1>{props.data.city}</h1>
          <ul>
            <li>
              <FormattedDate date={props.data.date} />
            </li>
            <li className="text-capitalize">{props.data.description}</li>
            <li>
              Humidity:{" "}
              <span className="WeatherParameterValue">
                {props.data.humidity}%
              </span>
              , Wind:{" "}
              <span className="WeatherParameterValue">
                {props.data.wind} km/h
              </span>
            </li>
          </ul>
        </div>

        <div className="col-lg-6 col-md-6 col-sm-8">
          <WeatherUnitConversion
            celsius={props.data.temperature}
            iconUrl={props.data.iconUrl}
            iconAlt={props.data.iconDescription}
          />
        </div>
      </div>
    </div>
  );
}
